const SKIP_LABELS = {
  application_not_verified: "application or renewal not verified yet (verify it first)",
  not_found: "not linked to an active membership payment",
  invalid_payment: "invalid payment id",
  invalid_flag: "invalid verification flag",
  unknown: "other",
};

/**
 * Human-readable suffix for accountant membership payment bulk verify responses.
 * @param {Record<string, number>|undefined} skipReasons
 */
export function formatMembershipBulkPaymentSkipSuffix(skipReasons) {
  if (!skipReasons || typeof skipReasons !== "object") return "";
  const parts = Object.entries(skipReasons)
    .filter(([, n]) => Number(n) > 0)
    .map(([code, n]) => `${n} ${SKIP_LABELS[code] || String(code).replace(/_/g, " ")}`);
  if (!parts.length) return "";
  return ` Skipped because: ${parts.join("; ")}.`;
}
